"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
const DANGER_LIMIT = 3;
const WARNING_LIMIT = 10;

/* eslint-disable react/prop-types */
const CharacterCounter = _ref => {
  let {
    limit,
    count,
    ...props
  } = _ref;
  const text = limit - count;
  if (text <= DANGER_LIMIT) {
    return /*#__PURE__*/_react.default.createElement(_styles.DangerCounter, props, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": true
    }, text));
  }
  if (text <= WARNING_LIMIT) {
    return /*#__PURE__*/_react.default.createElement(_styles.WarningCounter, props, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": true
    }, text));
  }
  return /*#__PURE__*/_react.default.createElement(_styles.RegularCounter, props, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": true
  }, text));
};
/* eslint-enable react/prop-types */
var _default = exports.default = CharacterCounter;
CharacterCounter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CharacterCounter"
};